const OneNetworkConfig = {
  baseRoutePath: '/dashboard',
  frontpageUrl: import.meta.env.VITE_FRONTPAGE_URL,
  fileBaseUrl: import.meta.env.VITE_FILE_BASE_URL,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  map: {
    apiKey: import.meta.env.VITE_MAP_API_KEY || 'AIzaSyD7cdII3LvlSVbCYzBrU8zKVoR0-VDlgJU',
  }
}
export default OneNetworkConfig
